import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: '', value: 'expand_action', width: '10' },
  { text: 'Username', value: 'username' },
  { text: 'Role', value: 'role'},
  { text: 'Action', value: 'action_api'},
  { text: 'Location Menu', value: 'custom'},
  { text: 'IP Address', value: 'ip_address'},
  { text: 'Action Date', value: 'inserted'},
  { text: 'Status', value: 'custom_status', width: '10' },
]);

export const search = {
  action_date: [],
  username: '',
  role: '',
  origin_path: '',
  ip_address: '',
  status: '',
  action:''
};